import axios from 'axios'
import store from 'src/vuex/store'
import Vue from 'vue'
import responseErrorHandler from 'src/assets/js/functions/responseErrorHandler'

let loader = null
let requestCounter = 0

axios.defaults.baseURL = process.env.SERVER_API

axios.interceptors.request.use(function (config) {
	if (store.getters['user/isLoggedIn']) {
		config.headers.common['Authorization'] = `${store.state['user'].token_type} ${store.state['user'].token}`
	}	else if (localStorage.getItem('access_token') && localStorage.getItem('token_type')) {
		config.headers.common['Authorization'] = `${localStorage.getItem('token_type')}  ${localStorage.getItem('access_token')}`
	}

	const isSearch =
		config.hasOwnProperty('params') &&
		config.params.hasOwnProperty('search') &&
		Object.keys(config.params).length < 2

	if (config.withoutLoader || isSearch) {
		return config
	}

	requestCounter++
	if (requestCounter > 0 && !loader) {
		loader = Vue.$loading.show({
			container: null
		})
	}
	return config
}, function (error) {
	return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
	if (!response.config.withoutLoader) {
		requestCounter--
	}

	if (requestCounter <= 0 && loader) {
		requestCounter = 0
		loader.hide()
		loader = null
	}

	if (response.status === 200 && response.data.messages && response.data.messages.length) {
		const messages = Array.isArray(response.data.messages) ? response.data.messages : [response.data.messages]
		global.toastr['success'](...messages)
	}
	if (response.status === 201) {
		const messages = Array.isArray(response.data.messages) ? response.data.messages : [response.data.messages]
		global.toastr['success'](...messages)
	}
	if (response.status >= 300) {
		const messages = Array.isArray(response.data.messages) ? response.data.messages : [response.data.messages]
		global.toastr['warning'](...messages, `Перенаправление ${response.status}`)
	}
	return response
}, function (error) {
	if (!(error.response && error.response.config && error.response.config.withoutLoader)) {
		requestCounter--
	}

	if (requestCounter <= 0 && loader) {
		requestCounter = 0
		loader.hide()
		loader = null
	}
	responseErrorHandler(error)
	return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/assets/js/axiosInit.js